import $ from 'jquery';
import { nodeConfig } from '@/mixins';
import { mod } from '@/helpers/utils';
import { Swap } from '@/plugins/swap';

const NAMESPACE = 'accordion';
const DEFAULT_SELECTOR = '[data-js-accordion]';
const DEFAULT_SETTINGS = {
	grouped: false,
};

class Accordion {
	constructor(node, config) {
		this.$node = $(node);
		this.config = config;
		this.groupId = node.id;

		this.$swaps = this.$node.find('[data-js-accordion-swap]');
		this.$items = this.$node.find('[data-js-accordion-item]');
	}

	get hasActive() {
		return this.$node.find('.fs-swap-active').length;
	}

	focusFirst() {
		this.$items.first().find('[data-js-accordion-swap]').trigger('focus');
	}

	focusLast() {
		this.$items.last().find('[data-js-accordion-swap]').trigger('focus');
	}

	onTriggerKeydown(event) {
		let keyCode = event.key.toLowerCase();

		if (!['home', 'end', 'arrowup', 'arrowdown'].includes(keyCode)) return;

		let $focusedElement = $(':focus');
		let $focusedItem = $focusedElement.closest('[data-js-accordion-item]');
		let focusedIndex = this.$items.index($focusedItem);

		event.preventDefault();

		let lookup = {
			home: () => {
				this.focusFirst();
			},
			end: () => {
				this.focusLast();
			},
			arrowup: () => {
				let prevIndex = mod(focusedIndex - 1, this.$items.length);
				this.$items.eq(prevIndex).find('[data-js-accordion-swap]').trigger('focus');
			},
			arrowdown: () => {
				let nextIndex = mod(focusedIndex + 1, this.$items.length);
				this.$items.eq(nextIndex).find('[data-js-accordion-swap]').trigger('focus');
			}
		};

		if (keyCode in lookup) {
			lookup[keyCode]();
		}
	}

	fragmentIdentifier() {
		let fragment = decodeURIComponent(window.location.hash);

		if (!fragment) return;

		let elTarget = document.querySelector(fragment);

		if (!elTarget) return;

		Swap.activate(elTarget.querySelector('[data-js-swap]'));
	}

	bindUI() {
		this.$swaps.on({
			keydown: this.onTriggerKeydown.bind(this)
		});
	}

	setup() {
		this.$swaps.each((_, elSwap) => {
			const swapConfig = {
				target: elSwap.closest('[data-js-accordion-item]'),
				triggerAttributes: [
					{
						attribute: 'aria-expanded',
						on: 'true',
						off: 'false'
					}
				]
			};

			if (this.config.grouped && this.groupId) {
				swapConfig.group = this.groupId;
			}

			new Swap(elSwap, swapConfig);
		});
	}

	init() {
		this.setup();
		this.bindUI();
		this.fragmentIdentifier();
	}
}

export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	let listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		let config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		let module = new Accordion(node, config);

		module.init();

		return module;
	});
}
